import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createProhibitedItemList } from '@wayste/client-utils';
/**
 * Roll-off ordering footer copy: material + zone prohibited list via createProhibitedItemList.
 * Used in MaterialDetails and ServiceDetails footers (collapsible cards).
 */
export function ProhibitedItemsFooter({ material, defaultProhibitedItems }) {
    if (!material) {
        return null;
    }
    const summaryText = createProhibitedItemList(material, defaultProhibitedItems.length > 0 ? defaultProhibitedItems.join(', ') : null);
    return (_jsx("div", { className: "flex flex-col gap-2 pt-4", children: _jsxs("p", { className: "text-text-secondary font-inter text-sm leading-snug", children: [_jsx("span", { className: "text-text-primary font-medium", children: "Prohibited items:" }), " ", _jsx("span", { children: summaryText })] }) }));
}
//# sourceMappingURL=prohibited-items-footer.js.map